import { AuthActions } from "../reducers/AuthReducer";
import { UserActions } from "../reducers/UserReducer";
import store from "../store";
import client from "./client";

const API_URL = process.env.REACT_APP_API_URL;

export const login = async (username: string, password: string) => {
  try {
    const {
      data: { token, user },
    } = await client.post<{ token: string; user: { role: string } }>(
      `${API_URL}auth/login`,
      {
        username,
        password,
      }
    );
    if (user.role !== "admin") {
      alert("Your role is not authorized to access this page");
      throw new Error("Your role is not authorized to access this page");
    }
    store.dispatch({ type: AuthActions.SetSession, payload: { token, user } });
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));
  } catch (error) {
    console.error(error);
  }
};

export const initLogin = async () => {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user")!)

  if (!user) {
    localStorage.removeItem("token")
    store.dispatch({ type: AuthActions.DelSession, payload: null });
  }

  if (token) {
    try {
      await client.get(`${API_URL}auth/validate`, {
        headers: {
          "x-auth-token": token,
        },
      });
      store.dispatch({ type: AuthActions.SetSession, payload: { token, user: JSON.parse(localStorage.getItem("user") || "{}") } });
    } catch (error) {
      localStorage.removeItem("token");
      store.dispatch({ type: AuthActions.DelSession, payload: null });
    }
  }
};

export const showAllUsers = async () => {
  try {

    const { data } = await client.get(`${API_URL}auth/all`);
    const filteredUsers = data.users.filter((user: User) => user.role !== "admin");

    store.dispatch({ type: UserActions.ReceiveUsers, payload: filteredUsers });
  } catch (error) {
    console.error(error);
    store.dispatch({ type: UserActions.SetError, payload: "Error obteniendo los usuarios" });
  }
};

export const addUser = async (username: string, password: string) => {
  try {
    const { data } = await client.post(`${API_URL}auth/signup`, {
      username,
      password,
    });
    store.dispatch({ type: UserActions.AddUser, payload: data.user });
    return true;
  } catch (error) {
    console.error(error);
    store.dispatch({ type: UserActions.SetError, payload: "Error agregando el usuario" });
    return false;
  }
};

export const deleteUser = async (id: string) => {
  try {
    const { data } = await client.delete(`${API_URL}auth/delete/${id}`);

    console.log(data)
    store.dispatch({ type: UserActions.DeleteUser, payload: data.user });
    return true;
  } catch (error) {
    console.error(error);
    store.dispatch({ type: UserActions.SetError, payload: "Error eliminando el usuario" });
    return false;
  }
};

export const addMenuToUser = async (id: string, menu: Menu) => {
  try {

    console.log(id, menu)
    const { data } = await client.put(`${API_URL}auth/add/menu`, {
      userId: id,
      menu: menu,
    });

    store.dispatch({ type: UserActions.UpdateUser, payload: data.user });
    return true;
  } catch (error) {
    console.error(error);
    store.dispatch({ type: UserActions.SetError, payload: "Error editando el usuario" });
    return false;
  }
};

export const deleteMenuFromUser = async (id: string, menuName: string) => {
  try {
    const { data } = await client.put(`${API_URL}auth/remove/menu`, {
      userId: id,
      menuName: menuName,
    });
    store.dispatch({ type: UserActions.UpdateUser, payload: data.user });
    return true;
  } catch (error) {
    console.error(error);
    store.dispatch({ type: UserActions.SetError, payload: "Error editando el usuario" });
    return false;
  }
};

export const editMenuFromUser = async (id: string, menu: Menu) => {
  try {
    const { data } = await client.put(`${API_URL}auth/edit/menu`, {
      userId: id,
      menu: menu,
    });
    store.dispatch({ type: UserActions.UpdateUser, payload: data.user });
    return true;
  } catch (error) {
    console.error(error);
    store.dispatch({ type: UserActions.SetError, payload: "Error editando el usuario" });
    return false;
  }
};


export const updatePasswordAdmin = async (user: User, newPass: string) => {
  try {
    const response = await client.put(
      `${API_URL}auth/admin/update/password`,
      {
        user,
        newPass,
      }
    );

    if (response.status === 200) {
      alert("Password updated successfully");
    } else {
      alert("Error updating password");
      throw new Error("Error updating password");
    };
    return true;
  } catch (error) {
    console.error(error);
    throw new Error("Error updating password");
  }
};

export const updateUser = async (id: string, user: Partial<User>) => {
  try {
    const { data } = await client.put(`${API_URL}auth/edit/user/${id}`, {
      updatedUserData: user,
    });
    store.dispatch({ type: UserActions.UpdateUser, payload: data.user });
    return true;
  } catch (error) {
    console.error(error);
    store.dispatch({ type: UserActions.SetError, payload: "Error editando el usuario" });
    return false;
  }
};